import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  districts: null,
  loading: false,
  isProcessActionLoading: false,
  total: 0,
  sortableColumns: [],
  formInfo: {
    brands: [],
  },
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, sortableColumns } = payload;

  return {
    ...state,
    districts: data,
    filters,
    total,
    filteredTotal,
    loading: false,
    sortableColumns,
  };
}

function onLoadFormData(state, { payload }) {
  return { ...state, ...payload, loading: true };
}

function onLoadFormDataSuccess(state, { payload }) {
  return { ...state, ...payload, loading: false };
}

function onProcessAction(state) {
  return { ...state, isProcessActionLoading: true };
}

function onProcessActionSuccess(state) {
  return { ...state, isProcessActionLoading: false };
}

function onProcessActionFailure(state) {
  return { ...state, isProcessActionLoading: false };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.LOAD_FORM_DATA]: onLoadFormData,
  [actions.LOAD_FORM_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actions.PROCESS_ACTION]: onProcessAction,
  [actions.PROCESS_ACTION_SUCCESS]: onProcessActionSuccess,
  [actions.PROCESS_ACTION_FAILURE]: onProcessActionFailure,
});
